import { render, staticRenderFns } from "./tan_editmode.vue?vue&type=template&id=0a476a7a&scoped=true"
import script from "./tan_editmode.vue?vue&type=script&lang=js"
export * from "./tan_editmode.vue?vue&type=script&lang=js"
import style0 from "./tan_editmode.vue?vue&type=style&index=0&id=0a476a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a476a7a",
  null
  
)

export default component.exports